module.exports = __webpack_public_path__ + "media/gange.0194a8fc.mp3";